export default function tooltip (parent, trigger, target, targetActive) {
  console.log('Tooltip initialized');

  const parentElements = document.querySelectorAll(parent);

  Array.prototype.forEach.call(parentElements, function(parentElement) {
    const triggerElement = parentElement.querySelector(trigger);
    const targetElement = parentElement.querySelector(target);
    if (triggerElement && targetElement) {
      triggerElement.addEventListener('mouseenter', function(e) {
        e.preventDefault();
        targetElement.classList.toggle(targetActive);
      });
      triggerElement.addEventListener('mouseleave', function(e) {
        e.preventDefault();
        targetElement.classList.toggle(targetActive);
      });
    }
  });
}